<template>
  <el-dialog append-to-body width="500px" :title="title" :visible.sync="visible" :before-close="handleClose">
    <div class="modal-body">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="exampleModalLabel">您还未开通会员</h4>
          </div>
          <div class="modal-body">
            <p>请先开通会员完成身份认证，即可创建团体哦～</p>
            <div class="open-btn flex-cc"><router-link :to="{ path: '/vip' }">加入会员</router-link></div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import waves from '@/directive/waves' // 水波纹指令
export default {
  name: 'UnIdentity',
  components: {

  },
  directives: {
    waves
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default: '提示'
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  watch: {
    visible(value) {
      if (value) {

      }
    }
  },
  methods: {
    // 关闭窗口
    handleClose() {
      // 更新visible参数
      this.$emit('update:visible', false)
    }
  }
}
</script>
<style lang="scss" scoped>
.modal-body {
  width: 100%;
  font-size: 20px;
  font-weight: 400;
  color: #333333;
  padding-top: 39px;
  text-align: center;
}

.open-btn {
  width: 160px;
  height: 40px;
  background: #00B4E8;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 300;
  color: #FFFFFF;
  cursor: pointer;
  margin: 39px auto 0 auto;
}
</style>
